import PropTypes from "prop-types";
import React from "react";

const SelectFilter = ({ id, label, value, options, onChange }) => (
  <div className="filter-field">
    <label className="filter-field-label" htmlFor={id}>
      {label}
    </label>
    <select
      id={id}
      className="filter-field-control"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Todos</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

SelectFilter.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

const TextFilter = ({ id, label, value, onChange }) => (
  <div className="filter-field">
    <label className="filter-field-label" htmlFor={id}>
      {label}
    </label>
    <input
      id={id}
      type="text"
      className="filter-field-control"
      placeholder="Buscar..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

TextFilter.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const OnboardingFilters = ({
  values,
  courseOptions,
  fieldStepOptions,
  visibleCount,
  totalCount,
  onChange,
  onClear,
}) => {
  const hasActiveFilter = Object.keys(values).some((key) => values[key] !== "");
  const noun = totalCount === 1 ? "processo" : "processos";

  return (
    <div className="filter-bar">
      <div className="filter-bar-head">
        <h4 className="filter-bar-title">Filtrar processos</h4>
        <div className="filter-bar-status">
          <span aria-live="polite">
            {hasActiveFilter ? (
              <React.Fragment>
                Mostrando <strong>{visibleCount}</strong> de {totalCount} {noun}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {totalCount} {noun}
              </React.Fragment>
            )}
          </span>
          {hasActiveFilter && (
            <button
              type="button"
              className="filter-bar-clear"
              onClick={onClear}
            >
              Limpar filtros
            </button>
          )}
        </div>
      </div>

      <div className="filter-bar-fields">
        <SelectFilter
          id="onboarding-filter-course"
          label="Curso"
          value={values.course}
          options={courseOptions}
          onChange={(value) => onChange("course", value)}
        />
        <SelectFilter
          id="onboarding-filter-field-step"
          label="Ano / Período de promoção"
          value={values.fieldStep}
          options={fieldStepOptions}
          onChange={(value) => onChange("fieldStep", value)}
        />
        <TextFilter
          id="onboarding-filter-name"
          label="Processo"
          value={values.name}
          onChange={(value) => onChange("name", value)}
        />
        <TextFilter
          id="onboarding-filter-curriculum"
          label="Currículo"
          value={values.curriculum}
          onChange={(value) => onChange("curriculum", value)}
        />
      </div>
    </div>
  );
};

OnboardingFilters.propTypes = {
  values: PropTypes.shape({
    course: PropTypes.string,
    fieldStep: PropTypes.string,
    name: PropTypes.string,
    curriculum: PropTypes.string,
  }).isRequired,
  courseOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  fieldStepOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  visibleCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default OnboardingFilters;
